module.exports = __webpack_public_path__ + "static/media/blog.4e882084.svg";